import { array, struct, tuple } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as ClientId } from '../../client/Id';
import { Id as JobTypeId } from '../../job/job-type';
import { Id as RequirementId } from '../../report/RequirementsWithUnknown';
import { StageId as AssigneeTypeId } from '../StageId';
import { UserId } from '../UserId';

export const FilterRequest = struct({
	client: array(ClientId),
	jobType: array(JobTypeId),
	requirements: array(array(RequirementId)),
	assignee: array(UserId),
	assigneeType: array(AssigneeTypeId),
	completedAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
});
